export default __webpack_public_path__ + "static/media/logo_univ.b91384f6.png";